import BlurRadialSpotlight from '../../../Elements/BlurRadialSpotlight';
import Octocat from './Octocat';

import styles from './styles.module.css';

function GithubIllustration() {
	return (
		<div className={styles.container}>
			<div className={styles.octocat}>
				<Octocat />
			</div>

			<div className={styles['light-bottom']}>
				<BlurRadialSpotlight />
			</div>

			<div className={styles['light-top']}>
				<BlurRadialSpotlight />
			</div>
		</div>
	);
}

export default GithubIllustration;
